import React from "react"
import styled from "styled-components"

import padding from "@irati/ui/src/global/padding"
import media from "@irati/ui/src/global/media"
import id from "@irati/utils/id"
import {Wallet} from "@irati/types"
import CashIntro from "./Cash"
import PerkPoints from "./PerkPoints"

const Container = styled.div`
  ${media.desktop`
    margin-bottom: ${padding.small};
  `}
`

interface Props {
  wallet: Wallet
}

const Intro: React.FC<Props> = (props) => {
  const idNamespace = id("intro", props)
  const {currency} = props.wallet

  return (
    <Container id={idNamespace}>
      {currency === "TT" && <PerkPoints />}
      {currency !== "TT" && <CashIntro />}
    </Container>
  )
}

export default Intro
